import type { HttpGet } from '@/shared/infra/http'
import type { LoadHuntLabel } from '@/shared/domain/use-cases'

export class EdgeLoadHuntLabelRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadHuntLabel = async (params) => {
    try {
      const result = await this.http.get<{ hunt: Record<string, unknown> }>({
        url: `/hunts/${params.huntId}`,
      })
      const title = result.hunt.title
      const date = result.hunt.date
      if (typeof title !== 'string' || typeof date !== 'string') {
        return null
      }
      return { title, date }
    } catch {
      return null
    }
  }
}
